"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var PageHeader = function PageHeader(_ref) {
    var title = _ref.title, subhead = _ref.subhead, children = _ref.children, className = _ref.className, _ref$noRule = _ref.noRule, noRule = _ref$noRule === void 0 ? false : _ref$noRule, _ref$invert = _ref.invert, invert = _ref$invert === void 0 ? false : _ref$invert, _ref$accountPage = _ref.accountPage, accountPage = _ref$accountPage === void 0 ? false : _ref$accountPage, _ref$alignLeft = _ref.alignLeft, alignLeft = _ref$alignLeft === void 0 ? false : _ref$alignLeft;
    return /*#__PURE__*/ react_1.default.createElement(StyledPadding, Object.assign({
        accountPage: accountPage
    }, {
        className: className
    }), /*#__PURE__*/ react_1.default.createElement(StyledMargin, {
        accountPage: accountPage,
        alignLeft: alignLeft
    }, /*#__PURE__*/ react_1.default.createElement(Header, Object.assign({
        invert: invert,
        alignLeft: alignLeft
    }, {
        dangerouslySetInnerHTML: {
            __html: title
        }
    })), subhead && /*#__PURE__*/ react_1.default.createElement(Subhead, Object.assign({
        invert: invert,
        alignLeft: alignLeft
    }, {
        dangerouslySetInnerHTML: {
            __html: subhead
        }
    })), /*#__PURE__*/ react_1.default.createElement(Rule, {
        noRule: noRule,
        invert: invert
    }), children));
}; // Styling
var StyledPadding = styled_components_1.default(atoms_1.Padding).withConfig({
    displayName: "PageHeader__StyledPadding",
    componentId: "sc-1m9nuxl-0"
})(["", ""], function (props) {
    return !!props.accountPage ? 'padding-top: 0 !important;' : '';
});
var StyledMargin = styled_components_1.default(atoms_1.Margin).withConfig({
    displayName: "PageHeader__StyledMargin",
    componentId: "sc-1m9nuxl-1"
})(["position:relative;display:flex;flex-direction:column;align-items:", ";", ""], function (props) {
    return !!props.alignLeft ? 'flex-start' : 'center';
}, function (props) {
    return !!props.accountPage ? 'padding: 0 !important;' : '';
});
var Header = styled_components_1.default.h1.withConfig({
    displayName: "PageHeader__Header",
    componentId: "sc-1m9nuxl-2"
})(["max-width:480px;", " text-align:", ";color:", ";", "{max-width:688px;}", "{max-width:800px;}"], _theme_1.type.h1Uppercase, function (props) {
    return !!props.alignLeft ? 'left' : 'center';
}, function (props) {
    return !!props.invert ? _theme_1.palette.snow : _theme_1.palette.black;
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'));
var Subhead = styled_components_1.default.div.withConfig({
    displayName: "PageHeader__Subhead",
    componentId: "sc-1m9nuxl-3"
})(["max-width:420px;padding-top:8px;", " text-align:", ";color:", ";& > p{margin-bottom:0.75em;&:last-of-type{margin-bottom:0;}}", "{max-width:440px;padding-top:13px;}", "{max-width:600px;padding-top:11px;}", "{max-width:680px;padding-top:25px;}"], _theme_1.type.p, function (props) {
    return !!props.alignLeft ? 'left' : 'center';
}, function (props) {
    return !!props.invert ? _theme_1.palette.snow : _theme_1.palette.ink;
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Rule = styled_components_1.default.div.withConfig({
    displayName: "PageHeader__Rule",
    componentId: "sc-1m9nuxl-4"
})(["", " border-bottom:1px solid ", ";width:12%;padding-top:20px;", "{padding-top:33px;}", "{padding-top:40px;}", "{padding-top:47px;}"], function (props) {
    return props.noRule && "\n    display: none;\n  ";
}, function (props) {
    return !!props.invert ? _utils_1.rgba(_theme_1.palette.snow, 0.16) : _utils_1.rgba(_theme_1.palette.ink, 0.32);
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Typing
exports.default = PageHeader;
